import React from "react"

export const ShareTrackingHandler: React.FC = () => {
  return null
}
